import React from "react";
import ServiceCard from "./components/ServiceCard/ServiceCard";
import { Bot, Globe, MonitorSmartphone, Workflow } from "lucide-react";
import { Badge, Container, Description, Grid, Header, Title } from "./styles";

const Services = () => {
    return (
        <Container id="services">
            <Header>
                <Badge>
                    Nuestros Servicios
                </Badge>

                <Title>
                    Soluciones diseñadas para hacer crecer tu negocio
                </Title>

                <Description>
                    Creamos software a medida, aplicaciones web, 
                    soluciones de automatización
                    y contenido con inteligencia artificial para 
                    impulsar la transformación
                    digital de tu negocio.
                </Description>
            </Header>

            <Grid>
                <ServiceCard 
                    icon={<MonitorSmartphone size={32}/>}
                    title="Desarrollo de software"
                    description="Creamos soluciones personalizadas adaptadas a las necesidades de tu negocio."
                />

                <ServiceCard 
                    icon={<Globe size={32}/>}
                    title="Desarrollo Web"
                    description="Landing pages, sitios coporativos y aplicaciones web modernas."
                />

                <ServiceCard 
                    icon={<Workflow size={32}/>}
                    title="Automatización"
                    description="Optimizamos procesos para ahorrar tiempo y reducir errores."
                />

                <ServiceCard 
                    icon={<Bot size={32}/>}
                    title="IA Generativa"
                    description="Creamos contenido e integraciones impulsadas por inteligencia artificial."
                />
            </Grid>
        </Container>
    )
};

export default Services;